<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8 text-center text-navy mb-3">
        Please input all individuals who act as authorised signatories on behalf
        of the business. Any contacts that will need access to the account can
        also be added below.
      </div>
      <div
        class="col-12 col-lg-8"
        v-if="onboardingAccount.is_completed == false"
      >
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="input-group">
              <label class="">Business Role</label>

              <el-select
                class="w-100"
                :class="{ 'border-edit': newGuarantor.index >= 0 }"
                v-model="newGuarantor.business_role_id"
                placeholder="Business Role"
              >
                <el-option
                  v-for="role in businessRoles"
                  :key="role.id"
                  :label="role.name"
                  :value="role.id"
                  >{{ role.name }}</el-option
                >
              </el-select>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group mt-4 d-flex justify-content-between mb-0">
              <label class="mt-1"
                >Is this person a signatory?
                <span class="required-flag">*</span></label
              >
              <el-select
                v-model="newGuarantor.is_signatory"
                placeholder="Signatory"
                :class="{
                  'border-edit': newGuarantor.index >= 0,
                  'border-danger-select': form.errors.has('is_signatory'),
                }"
              >
                <el-option :label="'Yes'" :value="true"></el-option>
                <el-option :label="'No'" :value="false"></el-option>
              </el-select>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class=""
                >First Name <span class="required-flag">*</span></label
              >
              <div class="input-group">
                <input
                  type="text"
                  name="first_name"
                  class="form-control w-100"
                  v-model="newGuarantor.first_name"
                  placeholder="First Name"
                  :class="{
                    'border-edit': newGuarantor.index >= 0,
                    'is-invalid': form.errors.has('first_name'),
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class=""
                >Last Name <span class="required-flag">*</span></label
              >
              <div class="input-group">
                <input
                  type="text"
                  name="last_name"
                  class="form-control w-100"
                  v-model="newGuarantor.last_name"
                  placeholder="Last Name"
                  :class="{
                    'border-edit': newGuarantor.index >= 0,
                    'is-invalid': form.errors.has('last_name'),
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">Email <span class="required-flag">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  name="email"
                  class="form-control w-100"
                  v-model="newGuarantor.email"
                  placeholder="Email"
                  :class="{
                    'border-edit': newGuarantor.index >= 0,
                    'is-invalid': form.errors.has('email'),
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">Phone</label>
              <vue-tel-input
                inputId="phone"
                mode="international"
                class="w-100"
                :class="{ 'border-edit': newGuarantor.index >= 0 }"
                :onlyCountries="['AU', 'GB', 'NZ', 'US']"
                v-model="newGuarantor.phone"
              />
            </div>
          </div>
          <div class="col-12 col-lg-12">
            <address-not-found
              @update="updateAddress($event, newGuarantor)"
              :key="newGuarantor.not_found"
              :layout="4"
              :data="{
                not_found: newGuarantor.not_found,
                address: newGuarantor.address_atr,
              }"
            ></address-not-found>

            <div class="form-group" v-if="!newGuarantor.not_found">
              <label class="">Address</label>
              <div>
                <google-maps-autocomplete
                  class="w-100"
                  :value="newGuarantor.postal_address"
                  v-on:address-components="saveAddresses($event, newGuarantor)"
                  placeholder="10 Street Name"
                  :class="{ 'border-edit': newGuarantor.index >= 0 }"
                ></google-maps-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-12">
            <div class="form-group d-flex justify-content-start">
              <label class="pr-2 mt-2"
                >Does this person require access to the client portal?</label
              >
              <el-select
                v-model="newGuarantor.is_access_required"
                :class="{ 'border-edit': newGuarantor.index >= 0 }"
              >
                <el-option :label="'Yes'" :value="true"></el-option>
                <el-option :label="'No'" :value="false"></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-12 text-right">
            <el-button
              class="btn-primary text-right"
              @click="addContact"
              v-if="onboardingAccount.is_completed == false"
            >
              {{ newGuarantor.index >= 0 ? "Update" : "Add" }}
            </el-button>
          </div>
        </div>
      </div>
      <div
        :class="
          onboardingAccount.is_completed == false
            ? 'col-12 col-lg-4 border-left'
            : 'col-8'
        "
      >
        <div class="text-uppercase text-light-gold mb-2">Contacts Added</div>
        <div class="px-1">
          <div class="row">
            <div class="col-3 font-weight-bold">Role</div>
            <div class="col-4 font-weight-bold">Contact</div>
            <div class="col-3 font-weight-bold text-center">Signatory</div>
            <div class="col-2 font-weight-bold"></div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
          </div>
          <div
            v-if="guarantors.length == 0"
            class="row col-12 mt-2 text-grey fa-sm"
          >
            No data
          </div>
          <div
            class="row py-2"
            v-for="(addedContact, index) in guarantors"
            :key="index"
          >
            <div class="col-3">
              {{ getBusinessRoles(addedContact.business_role_id) }}
            </div>
            <div class="col-4">
              {{ addedContact.first_name }} {{ addedContact.last_name }}
            </div>
            <div class="col-3 text-center">
              <span class="text-success" v-if="addedContact.is_signatory"
                >Yes</span
              >
              <span class="text-danger" v-else>No</span>
            </div>
            <div class="col-2">
              <i
                class="fa fa-edit text-primary has-interaction"
                @click="editContact(addedContact, index)"
                v-if="onboardingAccount.is_completed == false"
              ></i>
              <i
                class="fa fa-trash text-danger has-interaction"
                @click="deleteContact(index)"
                v-if="onboardingAccount.is_completed == false"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex justify-content-between mt-4">
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressNotFound from "../../../../common/AddressNotFound.vue";
import Form from "form-backend-validation";
export default {
  components: {
    AddressNotFound,
  },
  props: {
    initial_lead: {
      type: Object,
    },
    businessRoles: {
      type: Array,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      form: new Form(),
      guarantors: [],
      newGuarantor: {
        business_role_id: "",
        not_found: false,
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        postal_address: "",
        address_atr: {},
        extra_attributes: {
          postal_address: "",
        },
        is_signatory: null,
        is_access_required: null,
      },
    };
  },
  created() {
    this.loadGuarantors();
  },
  methods: {
    resetForm() {
      this.newGuarantor = {
        business_role_id: "",
        not_found: false,
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        address_atr: {},
        extra_attributes: {
          address: "",
        },
        is_signatory: null,
        is_access_required: null,
        postal_address: null,
      };
    },
    deleteContact(index) {
      this.$confirm(
        "Are you sure you want to delete this contact?",
        "Confirm",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.guarantors.splice(index, 1);
        this.resetForm();
      });
    },
    addContact() {
      this.form.errors.clear();
      if (
        this.newGuarantor.first_name &&
        this.newGuarantor.last_name &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newGuarantor.email) &&
        this.newGuarantor.is_signatory !== null
      ) {
        if (this.newGuarantor.index >= 0) {
          this.guarantors = this.guarantors.map((contact, index) => {
            if (index == this.newGuarantor.index) {
              return this.newGuarantor;
            }
            return contact;
          });
        } else {
          this.guarantors.push({ ...this.newGuarantor });
        }
        this.resetForm();
      } else {
        let errors = {};
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newGuarantor.email)) {
          errors.email = "Please make sure the email is valid";
        }
        if (!this.newGuarantor.first_name) {
          errors.first_name = "Please enter a first name";
        }
        if (!this.newGuarantor.last_name) {
          errors.last_name = "Please enter a last name";
        }
        if (!this.newGuarantor.is_signatory) {
          errors.is_signatory = "Please select if this contact is a signatory";
        }
        this.form.errors.record(errors);
        console.log(errors);
        this.$message.error("Please fill in all required fields");
      }
    },
    getBusinessRoles(business_role_id) {
      if (business_role_id)
        return this.businessRoles.find((role) => role.id == business_role_id)
          .name;
      return null;
    },
    editContact(contact, index) {
      if (!contact.phone) {
        contact.phone = "";
      }
      this.newGuarantor = { ...contact };
      this.newGuarantor.index = index;
    },
    loadGuarantors() {
      // Assuming `this.lead` is where lead data is stored and it has a `guarantors` property
      if (
        this.initial_lead &&
        this.initial_lead.guarantors &&
        this.initial_lead.guarantors.length > 0
      ) {
        this.guarantors = this.initial_lead.guarantors.map((guarantor) => ({
          id: guarantor.id || "",
          not_found: false,
          business_role_id: guarantor.business_role_id,
          first_name: guarantor.first_name,
          last_name: guarantor.last_name,
          email: guarantor.email,
          phone: guarantor.phone,
          postal_address: guarantor.postal_address || "",
          address_atr: {},
          extra_attributes: {
            postal_address: guarantor.extra_attributes?.postal_address || "",
          },
          is_signatory: guarantor.is_signatory || "",
          is_access_required: guarantor.is_access_required || "",
        }));
      }
      // while (this.guarantors.length < 2) {
      //   this.guarantors.push({
      //     not_found: false,
      //     first_name: "",
      //     last_name: "",
      //     email: "",
      //     phone: "",
      //     address: "",
      //     address_atr: {},
      //     extra_attributes: { address: "" },
      //     send_verification_link: false,
      //   });
      // }
    },
    updateAddress(data, contact) {
      this.newGuarantor.extra_attributes = {
        postal_address: data.address,
        not_found: data.not_found,
      };
    },
    saveAddresses(event, contact) {
      this.newGuarantor.extra_attributes = { postal_address: event };
    },

    updateLead(step) {
      if (
        (this.guarantors.length == 0 ||
          this.guarantors.filter((g) => g.is_signatory).length == 0) &&
        step == "next"
      ) {
        if (this.guarantors.length == 0) {
          this.$message.error("Please add at least one contact");
        } else {
          this.$message.error(
            "Please ensure at least one contact is a signatory"
          );
        }
        return;
      }

      // Check if user has entered data but not added the contact
      const hasUnaddedContactData =
        this.newGuarantor.first_name ||
        this.newGuarantor.last_name ||
        this.newGuarantor.email ||
        this.newGuarantor.phone;

      if (
        hasUnaddedContactData &&
        step == "next" &&
        this.onboardingAccount.is_completed == false
      ) {
        this.$confirm(
          this.newGuarantor.index >= 0
            ? "Contact not update, proceeding to the next page will cancel this contact changes. Are you sure you want to continue?"
            : "Contact not added, proceeding to the next page will remove this contact. Are you sure you want to continue?",
          "Warning",
          {
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.proceedWithUpdate(step);
          })
          .catch(() => {
            // User canceled, do nothing
          });
      } else {
        this.proceedWithUpdate(step);
      }
    },

    proceedWithUpdate(step) {
      let lead = this.initial_lead;
      lead.guarantors = this.guarantors.filter(
        (g) => g.first_name && g.last_name && g.email
      );
      console.log(lead.guarantors);

      this.$emit("update-lead", lead, step);
    },
  },
};
</script>
<style>
.border-edit,
.border-edit > input {
  border: 1px solid #2eadbb !important;
}
.border-danger-select input {
  border-color: #f86c6b !important;
}
</style>
